<div class="fixed inset-0 z-50 flex items-start justify-center bg-black/50 pt-8 px-4 pb-8"
  [class.opacity-0]="!isVisible" [class.opacity-100]="isVisible" (click)="closeModal()">
  <div class="bg-white dark:bg-slate-800 w-full max-w-2xl rounded-2xl shadow-xl overflow-hidden transition-all"
    [class.translate-y-4]="!isVisible" [class.translate-y-0]="isVisible" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-700">
      <div>
        <h2 class="text-xl font-bold text-slate-800 dark:text-slate-100">รายละเอียดการสมัครสมาชิก</h2>
        <p *ngIf="data?.requestNo" class="text-sm text-slate-500 mt-0.5">{{ data?.requestNo }}</p>
      </div>
      <button (click)="closeModal()" class="text-slate-400 hover:text-rose-500 text-3xl leading-none">&times;</button>
    </div>

    <div *ngIf="isLoading" class="p-12 text-center text-slate-400">กำลังโหลด...</div>

    <div *ngIf="!isLoading && data" class="p-6 space-y-4 max-h-[70vh] overflow-y-auto">
      <div class="flex items-center justify-between">
        <span class="px-3 py-1 rounded-full text-xs font-bold" [ngClass]="statusClass(data.displayStatus ?? 0)">
          {{ statusLabel(data.displayStatus ?? 0) }}
        </span>
        <div class="flex items-center gap-2" *ngIf="canEdit && !editMode">
          <button (click)="onCancel()"
            class="px-4 py-2 rounded-lg border border-rose-200 dark:border-rose-900/50 text-rose-600 dark:text-rose-400 text-sm font-bold bg-white dark:bg-slate-800 hover:bg-rose-50 dark:hover:bg-rose-900/30">
            ยกเลิกรายการ
          </button>
          <button (click)="startEdit()"
            class="px-4 py-2 rounded-lg bg-amber-400 text-white text-sm font-bold hover:bg-amber-500">
            แก้ไข
          </button>
        </div>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">ชื่อสมาชิก</label>
          <p class="font-medium text-slate-800 dark:text-slate-100">{{ data.memberName || '-' }}</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">เบอร์โทร</label>
          <input *ngIf="editMode" [(ngModel)]="phone" maxlength="10"
            class="w-full mt-1 px-3 py-2 border rounded-lg dark:bg-slate-700 dark:border-slate-600" />
          <p *ngIf="!editMode" class="font-medium">{{ data.phone || '-' }}</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">ทะเบียนรถ</label>
          <select *ngIf="editMode" [(ngModel)]="selectedVehicleId"
            class="w-full mt-1 px-3 py-2 border rounded-lg dark:bg-slate-700 dark:border-slate-600">
            <option [ngValue]="null" disabled>เลือกทะเบียนรถ</option>
            <option *ngFor="let v of vehicleOptions" [ngValue]="v.vehicleId">{{ v.label }}</option>
          </select>
          <p *ngIf="!editMode" class="font-medium">
            {{ data.license || '-' }}<span *ngIf="data.province" class="text-slate-400"> ({{ data.province }})</span>
          </p>
          <p *ngIf="editMode" class="text-xs text-amber-600 mt-1">เลือกจากรถของผู้ใช้เท่านั้น — ไม่สามารถเพิ่มทะเบียนใหม่</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">แพ็คเกจ</label>
          <select *ngIf="editMode" [(ngModel)]="selectedFeeId"
            class="w-full mt-1 px-3 py-2 border rounded-lg dark:bg-slate-700 dark:border-slate-600">
            <option [ngValue]="null" disabled>เลือกแพ็คเกจ</option>
            <option *ngFor="let f of feeOptions" [ngValue]="f.value">{{ f.label }}</option>
          </select>
          <p *ngIf="!editMode" class="font-medium">{{ data.feeName || '-' }} ({{ data.fee | number:'1.0-0' }} ฿)</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">วันหมดอายุ</label>
          <p class="font-medium text-rose-600 dark:text-rose-400">{{ formatDateTime(data.expireDate) }}</p>
          <p class="text-xs text-slate-400 mt-0.5">ห้ามแก้ไข — แสดงผลเท่านั้น</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">วันที่สมัคร</label>
          <p class="font-medium">{{ formatDateTime(data.createDate) }}</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">วันเริ่มใช้งาน</label>
          <p class="font-medium">{{ formatDateTime(data.memberStart) }}</p>
        </div>
        <div>
          <label class="text-slate-400 text-xs font-bold uppercase">วันสิ้นสุด</label>
          <p class="font-medium">{{ formatDateTime(data.memberEnd) }}</p>
        </div>
        <div *ngIf="data.paymentDate">
          <label class="text-slate-400 text-xs font-bold uppercase">วันที่ชำระ</label>
          <p class="font-medium">{{ formatDateTime(data.paymentDate) }}</p>
        </div>
      </div>

      <div>
        <label class="text-slate-400 text-xs font-bold uppercase">หมายเหตุ</label>
        <textarea *ngIf="editMode" [(ngModel)]="remarks" rows="3"
          class="w-full mt-1 px-3 py-2 border rounded-lg dark:bg-slate-700 dark:border-slate-600"></textarea>
        <p *ngIf="!editMode" class="font-medium whitespace-pre-wrap">{{ data.remarks || '-' }}</p>
      </div>

      <p *ngIf="!canEdit" class="text-sm text-rose-500 bg-rose-50 dark:bg-rose-900/20 rounded-lg px-4 py-3">
        แก้ไขได้เฉพาะรายการที่ยังไม่ชำระและยังไม่หมดอายุเท่านั้น
      </p>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex justify-between gap-2">
      <button type="button" *ngIf="id > 0" (click)="openActivityHistory()" [disabled]="isSaving || isLoading"
        class="px-4 py-2 rounded-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 inline-flex items-center gap-1.5 disabled:opacity-50 cursor-pointer">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-2 ml-auto">
        <button *ngIf="editMode" (click)="cancelEdit()" [disabled]="isSaving"
          class="px-4 py-2 rounded-lg border text-slate-600">ยกเลิก</button>
        <button *ngIf="editMode" (click)="saveEdit()" [disabled]="isSaving"
          class="px-4 py-2 rounded-lg bg-emerald-500 text-white font-bold disabled:opacity-50">
          {{ isSaving ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
        <button *ngIf="!editMode" (click)="closeModal()"
          class="px-4 py-2 rounded-lg border text-slate-600">ปิด</button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && id"
  [entityType]="activityEntityTypes.RegisterMember"
  [entityId]="id"
  title="ประวัติสมัครสมาชิก"
  [subtitle]="'#' + id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-confirm-modal *ngIf="showCancelModal"
  title="ยืนยันการยกเลิกรายการ?"
  message="คุณต้องการยกเลิกการสมัครสมาชิกของ"
  [highlight]="data?.memberName || ''"
  messageSuffix="ใช่หรือไม่?"
  confirmLabel="ยืนยันยกเลิก"
  cancelLabel="ยกเลิก"
  (confirm)="confirmCancel()"
  (cancel)="closeCancelModal()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isCancelling"></app-pss-loading>

